import { detectBrazilianDocumentKind, normalizeBrazilianDocument } from './normalize';
import { CNPJ_LENGTH, CPF_LENGTH } from './types';

/** Formata CPF: 000.000.000-00 */
export function formatCpf(value: string): string {
  const clean = normalizeBrazilianDocument(value);
  if (clean.length !== CPF_LENGTH || !/^\d+$/.test(clean)) {
    return value;
  }
  return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

/** Formata CNPJ numérico ou alfanumérico: XX.XXX.XXX/XXXX-XX */
export function formatCnpj(value: string): string {
  const clean = normalizeBrazilianDocument(value);
  if (clean.length !== CNPJ_LENGTH) {
    return value;
  }
  return clean.replace(/^(.{2})(.{3})(.{3})(.{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

/** Formata CPF ou CNPJ conforme o tipo detectado. */
export function formatCpfCnpj(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  if (typeof value !== 'string') {
    return String(value);
  }

  const clean = normalizeBrazilianDocument(value);
  if (!clean) {
    return '';
  }

  const kind = detectBrazilianDocumentKind(clean);
  if (kind === 'cpf' && clean.length === CPF_LENGTH) {
    return formatCpf(clean);
  }
  if (kind === 'cnpj' && clean.length === CNPJ_LENGTH) {
    return formatCnpj(clean);
  }

  return value;
}
